import { motion } from 'framer-motion';
import styled from 'styled-components';

type STooltipPosition = 'top' | 'right' | 'bottom' | 'left';

export const STooltipContainer = styled.div`
  position: relative;
`;

const tooltipPosMap: Record<STooltipPosition, string> = {
  top: `
    bottom: 100%;
    left: 0;
  `,
  right: `
    left: 100%;
    top: 0;
  `,
  bottom: `
    top: 100%;
    left: 0;
  `,
  left: `
    right: 100%;
    top: 0;
  `,
};

const getPosition = (pos: STooltipPosition) => tooltipPosMap[pos];

export const STooltip = styled(motion.div)<any>`
  display: inline-block;
  flex-direction: column;
  position: absolute;
  ${({ position }) => getPosition(position)}
  background-color: rgba(0, 0, 0, 0.64);
  z-index: 9999999999999;
  border-radius: 8px;
  transition: opacity 300ms;
  padding: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  z-index: 99;
`;

export const STooltipParagraph = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.grey0};
  max-width: 300px;
  margin: 0;
  white-space: pre-line;
`;
